import React, { useEffect, useState } from 'react';
import { fmesh } from '../../../core/globalVariables.js';

const RenderedPTagsWithKey = ({
  selectedLandTypes,
  handleLandtypePTagClick,
  uniqueTextureNamesArray,
  setcomparingLandtypeSelectedOption,
  longstandingGeoJSONRef,
  selectedYearEditing,
  compareSelectedKey,
  setCompareSelectedKey,
  landKeySelectedKey,
  setLandKeySelectedKey
}) => {
  const [legendData, setLegendData] = useState([]);

  // Get the GeoJSON data
  const geojson = longstandingGeoJSONRef.current;

  // Extract keys dynamically based on the selected year
  const availableKeys = Array.from(
    new Set(
      geojson.features.flatMap((feature) =>
        Object.keys(feature.feature_data_simple_timeseries || {})
      )
    )
  );

  // Get the values for the selected key in the selected year
  const items = landKeySelectedKey
    ? Array.from(
        new Set(
          geojson.features
            .map(
              (feature) =>
                feature.feature_data_simple_timeseries[landKeySelectedKey]?.[selectedYearEditing]
            )
            .filter((value) => value !== undefined)
        )
      )
    : [];

  const reset = 'Reset';

  useEffect(() => {
    if (landKeySelectedKey) {
      setCompareSelectedKey(landKeySelectedKey);

      const timeSeriesArray = [];
      fmesh.traverse((child) => {
        if (child.isMesh) {
          for (let i = 0; i < geojson.features.length; i++) {
            if (child.name === geojson.features[i].skylark_id) {
              const timeSeriesData = geojson.features[i].feature_data_simple_timeseries[compareSelectedKey]?.[selectedYearEditing];
              if (timeSeriesData) {
                const r = Math.round(child.material.color.r * 255);
                const g = Math.round(child.material.color.g * 255);
                const b = Math.round(child.material.color.b * 255);
                const hexColor = `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1).toUpperCase()}`;
                const uniqueEntry = { timeSeriesData, color: hexColor };

                if (!timeSeriesArray.some(entry => entry.timeSeriesData === uniqueEntry.timeSeriesData && entry.color === uniqueEntry.color)) {
                  timeSeriesArray.push(uniqueEntry);
                }
              }
            }
          }
        }
      });

      // Map legend data
      const legend = items.map((item) => {
        const matchingEntry = timeSeriesArray.find(entry => entry.timeSeriesData === item);
        return {
          label: item,
          color: matchingEntry ? matchingEntry.color : '#36A2EB' // Default color
        };
      });

      setLegendData(legend);
    }
  }, [landKeySelectedKey, compareSelectedKey, selectedYearEditing]);

  const comparingLandtypeSelected = (value) => {
    if (value === reset) {
      setcomparingLandtypeSelectedOption('none');
      return;
    }
    setcomparingLandtypeSelectedOption(value);
  };

  return (
    <>
      <div className="land_types_accum_compare">
        {items.map((item) => {
          const isSelected = selectedLandTypes.includes(item);

          const truncatedItem = typeof item === 'string' && item.length > 30 ? `${item.substring(0, 30)}...` : item || '';
          const matchingLegend = legendData.find((legend) => legend.label === item);

          return (
            <div
              key={item}
              onMouseMove={() => comparingLandtypeSelected(item)}
              onMouseOut={() => comparingLandtypeSelected(reset)}
              className={`land_type_list_general_p_compare ${isSelected ? 'selectedLandType' : ''}`}
            >
              <span
                className='color_circle'
                style={{ backgroundColor: matchingLegend ? matchingLegend.color : '#36A2EB' }}
              ></span>
              <div className="land_type_item_text">
                <p className="land_type_item_key">{truncatedItem}</p>
              </div>
            </div>
          );
        })}
      </div>

    </>
  );
};

export default RenderedPTagsWithKey;
